import type { NavigateFunction } from 'react-router-dom'

import { TipoDeNotificacao } from '@/enums/tipo-de-notificacao'

export interface ContextoDeAcaoDeNotificacao {
  navegar: NavigateFunction
}

export interface DefinicaoDeTipoDeNotificacao {
  titulo: string
  icone: string
  acao: (parametros: any, contexto: ContextoDeAcaoDeNotificacao) => void
}

interface ParametrosComDocumento {
  id_documento: number
}

function irParaODocumento(
  parametros: any,
  { navegar }: ContextoDeAcaoDeNotificacao
): void {
  const { id_documento } = parametros as ParametrosComDocumento

  if (!id_documento) return

  navegar(`/app/documento/${id_documento}`)
}

export const TIPOS_DE_NOTIFICACAO: Record<
  TipoDeNotificacao,
  DefinicaoDeTipoDeNotificacao
> = {
  [TipoDeNotificacao.ResponsavelIntegracaoAtribuido]: {
    titulo: 'Atribuição de responsabilidade',
    icone: 'fa-regular fa-user-plus',
    acao: irParaODocumento,
  },

  [TipoDeNotificacao.ResponsavelIntegracaoRemovido]: {
    titulo: 'Remoção de responsabilidade',
    icone: 'fa-regular fa-user-minus',
    acao: irParaODocumento,
  },

  [TipoDeNotificacao.ColaboradorIntegracaoIncluido]: {
    titulo: 'Inclusão de colaborador',
    icone: 'fa-regular fa-file-plus',
    acao: irParaODocumento,
  },

  [TipoDeNotificacao.ColaboradorIntegracaoRemovido]: {
    titulo: 'Remoção de colaborador',
    icone: 'fa-regular fa-file-minus',
    acao: irParaODocumento,
  },
}

export const DEFINICAO_DE_NOTIFICACAO_DESCONHECIDA: DefinicaoDeTipoDeNotificacao =
  {
    titulo: 'Notificação',
    icone: 'fa-regular fa-bell',
    acao: () => undefined,
  }

export function obterDefinicaoDoTipoDeNotificacao(
  tipo: TipoDeNotificacao
): DefinicaoDeTipoDeNotificacao {
  return TIPOS_DE_NOTIFICACAO[tipo] ?? DEFINICAO_DE_NOTIFICACAO_DESCONHECIDA
}
